import * as React from "react"
import { useLoaderData, useRouteLoaderData } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import PageWrapper from "@app/components/PageWrapper"
import FormSummary from "@app/components/FormSummary"
import FormNavigationButtons from "@app/components/FormNavigationButtons"
import { useWizardSteps } from "@app/lib/hooks/useWizardSteps"
import { nextStep } from "@app/utils/inspection"
import InspectionSyncState from "@app/components/InspectionSyncState"
import Config from "@app/constants/Config"
import { updateInspection } from "@app/models/inspection"
import { INITIAL } from "@app/constants/Constants"
import { getCurrentOffice } from "@app/models/office"
import SignsOverlayButton from "@app/components/SignsOverlayButton"

export const action = async ({ request, params }) => {
	const { inspectionId } = params

	const formData = await request.formData()
	const data = await JSON.parse(formData.get("json"))

	// send inspection
	const action = await updateInspection(inspectionId, data, 6, "INITIAL")
	if (action?.saveAsync) {
		await action.saveAsync()
	}
	return null
}

export const loader = async ({ params }) => {
	const { inspectionId } = params
	const currentOffice = await getCurrentOffice();

	return {
		nextStep: await nextStep("summary", inspectionId),
		currentOffice,
	}
}

export default function Summary () {
	const { inspection, inspectionConfig } = useRouteLoaderData("inspection")
	const { nextStep } = useLoaderData()
	const wizardSteps = useWizardSteps()
	const steps = {
		...wizardSteps,
		nextPath: nextStep,
	}

	return (
		<>
			<PageWrapper valign={"center"}>
				<InspectionSyncState />
				<SignsOverlayButton />
				<Container>
					<Row>
						<Col>
							<h1 className={'mb-60'}>Zusammenfassung</h1>
							<FormSummary
								values={inspection.values || {}}
								steps={[...inspectionConfig.forms.steps, inspectionConfig.forms.signsOverlayStep]}
								type={inspection.type}
								basePath={`${Config.BASE_PATH}/inspection/${inspection.uuid}/`}
							/>
							<FormNavigationButtons
								steps={steps}
								path={`${Config.BASE_PATH}/inspection/${inspection?.uuid}`}
								formikProps={{ values: inspection.values, errors: {} }}
								// onSubmit={onSubmit}
							/>
						</Col>
					</Row>
				</Container>
			</PageWrapper>
		</>
	)
}
